import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import jwt_decode from 'jwt-decode';

import { Auth } from '@angular/fire/auth';
import { GlobalStorage } from 'src/app/apv/core/services/globals.service';
import { BffService } from 'src/app/apv/core/services/http/bff.http.service';
import { IonicStorageService } from 'src/app/apv/core/services/storage/ionic/storage.service';
import { toTitleCase } from 'src/app/apv/core/utils/functions';
import {
  ACTIVE_SUBSCRIPTIONS_CCV,
  APP_USER,
  DEFAULT_EXECUTIVE,
  ENABLE_CCV_CAV_ACCOUNT_DETAIL_GO_BACK_BTN,
  FUNCTIONALITY,
  IS_FAILED_SUBSCRIPTION,
  MAIL_REGEX,
  PRODUCT_TYPE
} from 'src/app/shared/common/constants';
import { IStopSubscription } from 'src/app/shared/interfaces/stop.subscription.interface';
import { ICurrentSubscription } from 'src/app/shared/interfaces/subscription.interface';
import { INFO_TEXT } from './stop-subscr-modal.component.constant';
@Component({
    selector: 'app-stop-subscr-modal',
    templateUrl: './stop-subscr-modal.component.html',
    styleUrls: ['./stop-subscr-modal.component.scss'],
    standalone: false
})
export class StopSubscrModalComponent implements OnInit {
  subscriptionDataToStop!: ICurrentSubscription;
  formattedEmployer: string = '';

  isStopSubscriptionButtonDisabled = false;
  isSpinnerVisible = false;
  isFocusButtonSecondary = false;
  infoText = INFO_TEXT;
  token: string = '';

  public mailForm = new FormGroup({
    email: new FormControl('', [
      Validators.required,
      Validators.pattern(MAIL_REGEX),
    ]),
  });

  constructor(
    private readonly globalSvc: GlobalStorage,
    private readonly router: Router,
    private readonly bffSvc: BffService,
    private readonly ionicStorage: IonicStorageService,
    private readonly firebaseAuth: Auth
  ) {}

  async ngOnInit() {
    this.token =  String(await (
      await this.firebaseAuth.currentUser
    )?.getIdToken());

    this.getDataFromStorage();

    this.mailInputOnInit();
  }

  private getDataFromStorage() {
    const subscriptionData = sessionStorage.getItem('subscriptionDataToStop');
    if (subscriptionData) {
      this.subscriptionDataToStop = JSON.parse(subscriptionData);
    }
  }

  stopSubscription(): void {
    this.isStopSubscriptionButtonDisabled = true;
    this.isSpinnerVisible = true;

    this.getUserDataFromToken();
    this.sendStopSubscriptionRequest();
  }

  private async sendStopSubscriptionRequest(): Promise<void> {
    const data = this.buildDataToSend();

    this.globalSvc.stopSubscriptionEmployerData = {
      business: this.subscriptionDataToStop.employerName,
      rut: this.subscriptionDataToStop.employerRut,
      email: String(this.mailForm.get('email')?.value),
      pdf: {},
    };

    try {
      const res = await this.bffSvc.stopSubscription(data, this.token);

      this.globalSvc.stopSubscriptionDocumentNumber =
        res.data.data.status.data.status.Revocacion[0].folio;
      this.globalSvc.stopSubscriptionEmployerData.pdf =
        res.data.data.status.data.status.pdf;

      await this.ionicStorage.remove(ACTIVE_SUBSCRIPTIONS_CCV);
      this.router.navigate(['/home/ccv/successful-stop']);
    } catch (error: any) {
      console.error('[StopSubscription]' + '[Error] ', error.message);
      this.isStopSubscriptionButtonDisabled = false;
      this.isSpinnerVisible = true;
    }
  }

  private buildDataToSend(): IStopSubscription {
    return {
      user: APP_USER,
      employer: {
        rut: +this.subscriptionDataToStop.employerRut.slice(0, -1),
        checkDigit: String(this.subscriptionDataToStop.employerRut.slice(-1)),
        name: this.subscriptionDataToStop.employerName,
        email: String(this.mailForm.get('email')?.value),
        address: this.subscriptionDataToStop.employerAddress,
      },
      productType: PRODUCT_TYPE,
      requestNumber: this.subscriptionDataToStop.requestNumber,
      documentNumber: this.subscriptionDataToStop.DocumentNumber,
      fundTypeDestination: this.subscriptionDataToStop.fundTypeDestination,
      taxRegimeCode: this.subscriptionDataToStop.taxRegimeCode,
      discountValue: this.subscriptionDataToStop.discountValue,
      discountType: this.subscriptionDataToStop.discountType,
      name: toTitleCase(this.globalSvc.userData.name),
      functionality: FUNCTIONALITY,
      email: this.globalSvc.userData.email,
      executive: DEFAULT_EXECUTIVE,
    };
  }

  private getUserDataFromToken(): void {
    try {
      const decodedToken: any = jwt_decode(this.token);

      this.globalSvc.token = this.token;

      this.globalSvc.userData = {
        name: decodedToken.name,
        lastName: decodedToken.lastName,
        rut: decodedToken.user_id,
        email: decodedToken.email,
      };
    } catch (error) {
      console.error('Error getting user data from token');
      console.log(error);
    }
  }

  private mailInputOnInit(): void {
    if (this.subscriptionDataToStop.employerEmail) {
      this.mailForm
        .get('email')
        ?.setValue(this.subscriptionDataToStop.employerEmail);
    } else {
      this.mailForm.get('email')?.setValue('');
    }

    this.handleMailInputChange();
  }

  public handleMailInputChange(): void {
    this.isStopSubscriptionButtonDisabled = this.mailForm.get('email')
      ?.invalid as boolean;
  }

  public async mainVolverButton(): Promise<void> {
    const isFailedSubscription = await this.ionicStorage.get(
      IS_FAILED_SUBSCRIPTION
    );
    const goBackToDetail = await this.ionicStorage.get(ENABLE_CCV_CAV_ACCOUNT_DETAIL_GO_BACK_BTN);

    if (isFailedSubscription || !goBackToDetail) {
      await this.ionicStorage.remove(IS_FAILED_SUBSCRIPTION);
      this.router.navigate(['/home/ccv/']);
    } else {
      this.router.navigate(['/home/ccv/detail']);
    }
  }
  get isFormsButtonsDisabled(): boolean {
    return this.isStopSubscriptionButtonDisabled;
  }
  salir() {
    this.router.navigate(['/home/ccv/detail']);
  }
  focusButtonSecondary() {
    this.isFocusButtonSecondary = !this.isFocusButtonSecondary;
  }
}
